export default __webpack_public_path__ + "static/media/title_bg.8b4ece7e.svg";